import { useHomeFeed } from "@/hooks/use-home-feed";
import Seo from "@/components/Seo";
import HeroSection from "@/components/home/HeroSection";
import HomeFeed from "@/components/home/HomeFeed";
import TopKitsSection from "@/components/home/TopKitsSection";
import StatsBar from "@/components/home/StatsBar";

export default function Index() {
  const { user, loading, feedKits, topKits, stats, hasMore, loadingMore, loadMoreFeed, PAGE_SIZE, loadError, isRetrying, retry } = useHomeFeed();

  return (
    <div className="bg-background">
      <Seo
        title="LPUfootballshirts - Portal dla kolekcjonerów koszulek piłkarskich"
        description="Kataloguj, prezentuj i wymieniaj koszulki piłkarskie. Dołącz do społeczności kolekcjonerów."
        path="/"
      />
      {!user && <HeroSection />}
      {user && (
        <HomeFeed
          loading={loading}
          feedKits={feedKits}
          hasMore={hasMore}
          loadingMore={loadingMore}
          loadMoreFeed={loadMoreFeed}
          pageSize={PAGE_SIZE}
          loadError={loadError}
          isRetrying={isRetrying}
          retry={retry}

        />
      )}
      <TopKitsSection kits={topKits} />
      <StatsBar stats={stats} loading={loading} />
    </div>
  );
}